export default (obj, path, default_value) => {
    // 
    var i;
    let patharr = path.split(/\/|\./);
    for (i = 1; i < patharr.length - 1; i++) {
        if (obj[patharr[i]]) {
            obj = obj[patharr[i]];
        } else {
            obj[patharr[i]] = {}
            obj = obj[patharr[i]];
        }
    }
    return obj[patharr[i]] || default_value;
}
